import styled from 'styled-components';

const MenuIcon = styled.span<{ $enabled?: boolean }>`
    width: 21px;
    height: 21px;

    cursor: ${props => (props.$enabled ? 'pointer' : 'default')};
    touch-action: ${props => (props.$enabled ? 'auto' : 'none')};
    pointer-events: ${props => (props.$enabled ? 'auto' : 'none')};

    user-select: none;
`;

export default MenuIcon;
